<template>
  <div class="BannerDesignDetail">
    <div style="overflow: auto; height: 100%">
      <div
        class="designdetail__scroll"
        :style="{ transform: 'scale(' + scale / 100 + ')' }"
      >
        <div
          class="designdetail__scroll--item"
          v-for="(banner, index) of bannerDataList"
          :key="index"
        >
          <Banner
            :bannerName="banner.sizeName"
            :size="banner.size"
            :bannerTextValue="banner.textValue"
            :bgConfig="banner.bgParameter"
            :elementImg="banner.elementImg"
            :textStyle="banner.textStyle"
            :textInfo="banner.textInfo"
            :elConfig="banner.elementInfo"
          />
          <p class="designdetail__bannername">
            {{ banner.sizeName }}
            {{ banner.size.width + "x" + banner.size.height }}
          </p>
        </div>
      </div>
    </div>
    <div class="download_wrap">
      <Banner
        :id="'banner' + index"
        v-for="(banner, index) of bannerDataList"
        :key="banner.sizeId"
        :bannerName="banner.sizeName"
        :size="banner.size"
        :bannerTextValue="banner.textValue"
        :bgConfig="banner.bgParameter"
        :elementImg="banner.elementImg"
        :textStyle="banner.textStyle"
        :textInfo="banner.textInfo"
        :elConfig="banner.elementInfo"
      />
    </div>
    <div class="footer-panel">
      <span class="panel-btn" @click="preStep">返回 </span>
      <div class="panel-right">
        <span class="panel-btn" @click="editContent">编辑内容 </span>
        <span class="panel-btn" @click="editSize"> 编辑尺寸 </span>
        <span
          :class="['panel-btn', { disabled: !bannerDataList.length }]"
          v-loading="isDownLoading"
          element-loading-spinner="el-icon-loading"
          @click="downLoad"
          >{{ isDownLoading ? "下载中" : `下载(${bannerDataList.length})` }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { downloadBase64 } from "@/assets/scripts/utils.js";
import http from "@/plugins/http";
import api from "@/assets/scripts/api";
import Banner from "@/pages/banner/components/banner.vue";
import { mapMutations, mapState } from "vuex";
export default {
  name: "BannerDesignDetail",
  data() {
    return {
      schemeId: this.$route.query.schemeId,
      isDownLoading: false,
      guideAnimationVisible: true,
    };
  },
  components: {
    Banner,
  },
  computed: {
    ...mapState("banner", ["bannerDataList", "scale"]),
  },
  mounted() {
    this.getDesignDetail(this.schemeId);
  },
  methods: {
    ...mapMutations("banner", ["structBannerDataList"]),
    async getDesignDetail(schemeId) {
      let { data } = await http.get(
        `${api.scheme}?schemeId=${schemeId}&platformType=1`
      );
      this.structBannerDataList(data);
    },
    preStep() {
      this.$router.back(-1);
    },
    async editContent() {
      this.$router.push({
        path: "/banner/build",
        query: {
          schemeId: this.schemeId,
        },
      });
    },
    editSize() {
      this.$router.push({
        path: "/banner/size",
        query: {
          schemeId: this.schemeId,
        },
      });
    },
    async downLoad() {
      if (this.isDownLoading) return;
      this.isDownLoading = true;
      const downData = await downloadBase64(this.bannerDataList, "banner");
      if (downData.code === 10000) {
        this.$message.success("下载成功");
      }
      this.isDownLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.BannerDesignDetail {
  height: 100%;
  overflow: hidden;
  .download_wrap {
    overflow: hidden;
    z-index: -1;
    height: 0;
    width: 0;
  }
  .designdetail__scroll {
    transform-origin: 0 0;
    transition: all 0.2s;
    margin: 44px;
    padding-bottom: 100px;
    .designdetail__scroll--item {
      margin: 10px 0 40px;
      font-size: 16px;
      color: #183b56;
      .designdetail__banner {
        margin-bottom: 20px;
        background-color: #fff;
      }
      .designdetail__bannername {
        margin-top: 20px;
      }
    }
  }
}
</style>
